import React from "react";
import "./LogoMarquee.css";
import {
  FaDraftingCompass,
  FaCalculator,
  FaBuilding,
  FaHardHat,
  FaFileInvoiceDollar,
  FaRulerCombined,
  FaCity,
  FaProjectDiagram,
} from "react-icons/fa";

/* ------------------------------------------------------------------
 *  Capability strip — services Vezron actually handles.
 *  When you have real client logos, swap this for an image marquee.
 * ------------------------------------------------------------------ */
const CAPS = [
  { Icon: FaCalculator, label: "Cost Estimation" },
  { Icon: FaDraftingCompass, label: "CAD Drafting" },
  { Icon: FaFileInvoiceDollar, label: "Quantity Takeoff" },
  { Icon: FaBuilding, label: "Real Estate" },
  { Icon: FaHardHat, label: "Construction Support" },
  { Icon: FaRulerCombined, label: "Design & Markups" },
  { Icon: FaCity, label: "Property Brokerage" },
  { Icon: FaProjectDiagram, label: "Development Advisory" },
];

const LogoMarquee = () => {
  const items = [...CAPS, ...CAPS];

  return (
    <section className="logo-marquee">
      <p className="marquee-label">
        Specialized Capabilities · Serving India &amp; the USA
      </p>

      <div className="marquee-track-wrap">
        <div className="marquee-fade marquee-fade-left" />
        <div className="marquee-fade marquee-fade-right" />

        <div className="marquee-track">
          {items.map(({ Icon, label }, i) => (
            <div key={i} className="cap-item">
              <span className="cap-icon">
                <Icon />
              </span>
              <span className="cap-label">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
